import React from 'react'

import MainNav from './main-nav'
import AuthNav from './auth-nav'

const NavBar = () => {
  return (
    <div className="nav-container mb-3">
      <nav className="navbar navbar-expand-mds navbar-light bg-light">
        <div className="container flex-row-reverse">
          <div className="d-flex ml-auto">
            <AuthNav />
          </div>
          <div className="d-flex">
            <div className="navbar-brand logo" />
            <MainNav />
          </div>
        </div>
      </nav>
    </div>
  )
}

export default NavBar
